import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-pill-comanage-offer',
    templateUrl: './pill-comanage-offer.component.html',
    styleUrls: ['./pill-comanage-offer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class PillComanageOfferComponent implements OnInit {
    @Input() offer: any;

    constructor() {}

    ngOnInit(): void {}
}
